import React from 'react';
import styled from 'styled-components';
//
import { RichText } from './../../';
//
const Wrap = styled.div`
  margin: 0;
  padding: 0 0 1rem;

  @media (min-width: 768px) {
    background-color: #000;
    color: #fff;
    padding: 1rem;
  }

  h6 {
    text-decoration: underline;
  }

  a {
    text-decoration: underline;
  }
`;
//
export default ({ ...rest }) => (
  <Wrap>
    <RichText {...rest} />
  </Wrap>
);
